/* eslint-disable react/prop-types */

import React, { Component, createElement } from "react";
import ReactDOM from "react-dom";
import ContentLoader from "react-content-loader";

class PlaceholderCards extends Component {
  render() {
    const items = 6;
    let cards = new Array();
    for (let i = 0; i < items; i++) {
      cards.push(
        <div className="placeholder-cards__item" key={i}>
          <ContentLoader
            speed={2}
            width={240}
            height={350}
            viewBox="0 0 240 350"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
          >
            <circle cx="31" cy="31" r="15" />
            <rect x="58" y="18" rx="2" ry="2" width="140" height="10" />
            <rect x="58" y="34" rx="2" ry="2" width="140" height="10" />
            <polygon points="0 0 240 0 240 112 0 124"></polygon>
            <rect x="20" y="155" rx="2" ry="2" width="75" height="15" />
            <rect x="283" y="442" rx="0" ry="0" width="2" height="0" />
            <rect x="20" y="179" rx="2" ry="2" width="185" height="25" />
            <rect x="20" y="215" rx="2" ry="2" width="150" height="25" />
            <rect x="20" y="250" rx="2" ry="2" width="172" height="25" />
            <rect x="21" y="306" rx="15" ry="15" width="88" height="30" />
            <rect x="117" y="306" rx="15" ry="15" width="88" height="30" />
          </ContentLoader>
        </div>
      );
    }

    return (
      <div className="cards-placeholder__inner">
        <h2 className="cards-placeholder__loading">Aan het laden...</h2>
        <div className="placeholder-cards">{cards}</div>
      </div>
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  let el = document.getElementById("cards-placeholder");
  if (el === null) {
    return;
  }

  ReactDOM.render(createElement(PlaceholderCards), el);
});
